import React from 'react';
import Tabs from 'react-bootstrap/Tabs';

const TabContainer = ({children, defaultActiveKey,activeTab}) => {
    return (
        <Tabs mountOnEnter={true} unmountOnExit={true} defaultActiveKey={defaultActiveKey} 
        activeKey={activeTab} 
        id="uncontrolled-tab-example">
            {children}
        </Tabs>
    )
}

export default TabContainer
